import React from 'react'
import { Outlet } from 'react-router-dom';

const SopAndGuideline = () => {
  return (
    <><Outlet/></>
  )
}

export default SopAndGuideline